import { Action } from '../actions/vehicles';

const defaultState = {
  makes: [],
  isFetching: false,
  error: null,
};

export default function vehicleMakesReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Vehicle.FetchMakesPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    case Action.Vehicle.FetchMakesCompleted:
      return {
        ...state,
        isFetching: false,
        makes: body.makes || [],
      };

    case Action.Vehicle.FetchMakesFailed:
      return {
        ...state,
        isFetching: false,
        error: 'An error occurred fetching vehicle makes. Please try again later.',
      };

    default:
      return state;
  }
}
